import Vue from 'vue';
import Vuex, { Store } from 'vuex';

import user from './modules/user';
import home from './modules/home';
// import webSiteInfo from './modules/webSiteInfo';
import publicStore from './modules/public';
import message from './modules/message';

Vue.use(Vuex);

export default new Store({
  modules: {
    user,
    home,
    // webSiteInfo,
    message,
    publicStore
  },
  mutations: {
    // 滚动到顶部
    windowScrollToTop (state) {
      window.scrollTo(0, 0);
    }
  }
});
